module.exports = __webpack_public_path__ + "static/media/loader.2407b512.gif";